import { useState, useEffect } from 'react'

export const useFilteredData = (data, initialFilters = {}) => {
  const [filteredData, setFilteredData] = useState([])
  const [filters, setFilters] = useState({
    star: 'all', // true, false, all
    clustersOnly: false,
    tags: [],
    meetings: [],
    categories: [],
    sort: 'popular', // 'popular' or 'recent'
    ...initialFilters,
  })

  useEffect(() => {
    if (data.length) {
      let newData = JSON.parse(JSON.stringify(data))

      // Clusters-only filter: show only items that represent a cluster summary
      if (filters.clustersOnly) {
        newData = newData.filter((item) => Array.isArray(item.clustered_notes) && item.clustered_notes.length > 0)
      }

      if (typeof filters.star === 'boolean') {
        if (filters.star) {
          newData = newData.filter((item) => item.star)
        } else {
          newData = newData.filter((item) => !item.star)
        }
      }

      if (filters.tags.length) {
        newData = newData.filter((item) => filters.tags.every((tag) => item.tags.includes(tag)))
      }

      if (filters.meetings.length) {
        newData = newData.filter((item) => filters.meetings.includes(item.meetingId))
      }

      if (filters.categories?.length) {
        newData = newData.filter((item) => filters.categories.includes(item.category_id))
      }

      // Apply sorting based on sort filter
      if (filters.sort === 'popular') {
        // Sort by meetings_count (for clusters) in descending order
        newData.sort((a, b) => {
          // If items have meetings_count (clustered items), sort by that first
          if (a.meetings_count && b.meetings_count) {
            return b.meetings_count - a.meetings_count
          }
          // If only a has meetings_count, prioritize a
          else if (a.meetings_count) {
            return -1
          }
          // If only b has meetings_count, prioritize b
          else if (b.meetings_count) {
            return 1
          }
          // Otherwise sort by created_at as fallback
          return (b.created_at || 0) - (a.created_at || 0)
        })
      } else if (filters.sort === 'recent') {
        // Sort by created_at timestamp (newer first)
        newData.sort((a, b) => (b.created_at || 0) - (a.created_at || 0))
      }

      setFilteredData(newData)
    } else {
      setFilteredData([])
    }
  }, [data, filters])

  return { data: filteredData, filters, setFilters, setFilteredData }
}
